<template>
  <div class="home">

<!-- Background !darkMode -->
  <section>

    <div id="gg" :class="{ 'bgCloud' : !darkMode }">
      
        <div class="cloudShadow">

          <div id="cloud" v-if="!darkMode" class="cloud">
            <div class="roundCloudL"></div>
            <div class="roundCloudCB"></div>
            <div class="roundCloudCT"></div>
            <div class="roundCloudR"></div>
            <div class="roundCloudCR"></div>
          </div>
          <ul id="sun" v-if="!darkMode"  class="sun">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>

          <div class="textCloud" :class="{ 'hidden' : scrolling }">
            <h1 class="name">GASTRIN Cécile</h1>
            <h1 class="descr">Développeuse FullStack</h1>
        
            <p class="seeMore">Faites défiler pour en savoir plus !</p>
          </div>

          <span id="shadow" class="shadow"></span>
        </div>
      </div>
 </section>

<!-- Background darkMode -->

<section v-if="darkMode">
    <div :class="{ 'dark_mode': darkMode }">

      <div class="textCloudDark" :class="{ 'hidden' : scrolling }">
            <h1 class="nameD">GASTRIN Cécile</h1>
            <h1 class="descrC">Développeuse FullStack</h1>
        
            <p class="seeMoreD">Faites défiler pour en savoir plus !</p>
      </div>

      <div class="star star1"></div>
      <div class="star star2"></div>
      <div class="star star3"></div>
      <div class="star star4"></div>
      <div class="star star5"></div>
      <div class="star star6"></div>
      <div class="star star7"></div>
      <div class="star star8"></div>
    </div>
</section>



  <!-- Barre de nav !darkMode-->

<section v-if="!darkMode">

      <div v-if="!darkMode" class="navbar">
        <div class="logo">
          <router-link to="/"></router-link>
        </div>
        <ul class="links">
          <li>
            <router-link to="/"
            @mouseover="setHover('/')"
            @mouseleave="clearHover"
            :style="{
              color: currentRoute === '/' && !hoveredLink ? '#FDB813' : '#004080'
            }"
            >A propos</router-link>
          </li>
          <li>
            <router-link to="mescompetences"
            @mouseover="setHover('/mescompetences')"
            @mouseleave="clearHover"
            >Compétences</router-link>
          </li>
          <li>
            <router-link to="/projets"
            @mouseover="setHover('/projets')"
            @mouseleave="clearHover"
            >Projets</router-link>
          </li>
      <span></span>
        </ul>

        <a class="btnContact" href="#contact">Contact</a>
        <div class="toggle_btn">
          <img 
          :src="darkMode ? require('@/assets/barresD.png') : require('@/assets/barresTest.png')" 
          alt="barresNav"
          @click="toggleDropDown">
        </div>
      </div>

      <div :class="{ 'dropdown_menu' : !isDropdownOpen}">
        <div class="drop" v-if="!isDropdownOpen">
          <li>
            <a href="#about">A propos</a>
          </li>
          <li>
            <router-link to="/savoirsfaire">Compétences</router-link>
          </li>
          <li>
            <router-link to="/projets">Projets</router-link>
          </li>
          <li>
            <a class="btnContact" href="#contact">Contact</a>
          </li>
      </div>
    </div>


</section>

<!-- Barre de nav darkMode -->

<section v-if="darkMode">
<div :class="{ 'navNavDark' : darkMode }">

  <!-- Menu basic -->

  <div v-if="darkMode" class="navbar navbarDark">
        <div class="logo">
          <router-link to="/"></router-link>
        </div>
        <ul class="links">
          <li>
            <router-link to="/">A propos</router-link>
          </li>
          <li>
            <router-link to="/mescompetences">Compétences</router-link>
          </li>
          <li>
            <router-link to="/projets">Projets</router-link>
          </li>
      <span></span>
        </ul>
        <a class="btnContact" href="#contact">Contact</a>
        <div class="toggle_btn">
          <img 
          :src="darkMode ? require('@/assets/barresD.png') : require('@/assets/barresTest.png')" 
          alt="barresNav"
          @click="toggleDropDown">
        </div>
  </div>

<!-- Menu burger -->

  <div :class="{ 'dropdown_menu' : !isDropdownOpen}">
    <div class="drop" v-if="!isDropdownOpen">
      <li>
        <a href="#about">A propos</a>
      </li>
      <li>
        <router-link to="/mescompetences">Compétences</router-link>
      </li>
      <li>
        <router-link to="/projets">Projets</router-link>
      </li>
      <li>
        <a class="btnContact" href="#contact">Contact</a>
      </li>
    </div>
  </div>


</div>
</section>

<!-- à propos !darkmode -->

  <section v-if="!darkMode" id="about" class="about">
    <h1 class="aPropos">à propos</h1>

    <div class="aboutLeft">

      <div class="container">
        <div class="text">
            <div class="wrapper">
                <div id="H" class="letter">H</div>
                <div class="shadowText">H</div>
            </div>
            <div class="wrapper">
                <div id="E" class="letter">E</div>
                <div class="shadowText">E</div>
            </div>
            <div class="wrapper">
                <div id="Y" class="letter">Y</div>
                <div class="shadowText">Y</div>
            </div>
            <div class="wrapper">
                <div id="!" class="letter">!</div>
                <div class="shadowText">!</div>
            </div>
        </div>

    </div>
      

    </div>

    <div class="aboutRight">
      <h3>Bienvenue,</h3>
      <p class="aboutMe">Je suis Cécile Gastrin, passionnée par le développement web et diplômée en Développement Web et Web Mobile (DWWM).<br><br>
      Lors de ma formation, j’ai développé des compétences solides en front-end et back-end, notamment avec Figma, HTML, CSS, JavaScript, Vue.js, MySQL, PHP, Symfony et React.<br>
      Mon portfolio illustre ma passion pour le code et présente les projets que j'ai réalisés. Je suis actuellement en quête d’une alternance en tant que Conceptrice Développeuse d’Applications, disponible à partir de janvier 2025.<br><br>
      Je suis enthousiaste à l’idée de collaborer et d’échanger avec vous. N’hésitez pas à me contacter pour discuter de futures opportunités !</p>
    </div>

    <div class="boutonCv">
      <button @click="ouvrirCv" class="btnCv">Voir le CV</button>
    </div>

    <div v-if="!cvOpen" class="wrapper">
      <div class="popup">
        <div class="popup-inside">
          <div class="backgrounds">
            <div class="background"></div>
            <div class="background background2"></div>
            <div class="background background3"></div>
            <div class="background background4"></div>
            <div class="background background5"></div>
            <div class="background background6"></div>
          </div>
        </div>

        <div class="content">
          <div class="content-cv">
            <h1>Curriculum Vitae</h1>
            <iframe src="/images/cv.pdf" frameborder="0"></iframe>
            <button @click="fermerCv" class="close-btn">X</button>
          </div>
        </div>

      </div>
    </div>

  </section>

  
<!-- à propos darkMode -->


<section v-if="darkMode" id="about" class="about">
    <h1 class="aProposDark">à propos</h1>

    <div class="aboutLeftDark">

      <div class="container">
        <div class="textDark">
            <div class="wrapper">
                <div id="H" class="letter">H</div>
                <div class="shadowTextDark">H</div>
            </div>
            <div class="wrapper">
                <div id="E" class="letter">E</div>
                <div class="shadowTextDark">E</div>
            </div>
            <div class="wrapper">
                <div id="Y" class="letter">Y</div>
                <div class="shadowTextDark">Y</div>
            </div>
            <div class="wrapper">
                <div id="!" class="letter">!</div>
                <div class="shadowTextDark">!</div>
            </div>
        </div>

    </div>
      

    </div>

    <div class="aboutRightDark">
      <h3>Bienvenue,</h3>
      <p class="aboutMe">Je suis Gastrin Cécile, passionnée par le développement web et récemment formée en Développement Web et Web Mobile (DWWM).<br><br>
      Au cours de cette dernière, jai acquis des compétences en Figma, HTML, CSS, JavaScript, Vue, MySQL, PHP, Symfony et React. J'ai alors une solide expérience à la fois en front-end, comme en back-end. <br>
      Mon portfolio reflète ma passion pour le code, et je vous propose également de découvrir les projets que j'ai pu réaliser.<br>
      Je suis actuellement à la recherche d'une opportunité professionnelle en tant que Concepteur Développeur d'Application dans le cadre d'une alternance, disponible à partir du 23 Septembre 2024.<br>
      Je suis ouverte aux opportunités de collaboration et enthousiaste d'échanger avec vous. <br>
      N'hésitez pas à me contacter pour en discuter d'avantage.</p>
    </div>

    <div class="boutonCv">
      <button @click="ouvrirCv" class="btnCvDark">Voir le CV</button>
    </div>

    <div v-if="!cvOpen" class="wrapper">
      <div class="popup">
        <div class="popup-inside">
          <div class="backgrounds">
            <div class="background"></div>
            <div class="background background2"></div>
            <div class="background background3"></div>
            <div class="background background4"></div>
            <div class="background background5"></div>
            <div class="background background6"></div>
          </div>
        </div>

        <div class="contentDark">
          <div class="content-cvDark">
            <h1>Curriculum Vitae</h1>
            <iframe src="/images/cv.pdf" frameborder="0"></iframe>
            <button @click="fermerCv" class="close-btn">X</button>
          </div>
        </div>

      </div>
    </div>

  </section>




  <!-- Compétences -->

  <section v-if="!darkMode" class="competences">
    <h2>Mes compétences</h2>

    <div class="rounds">

      <div class="topCompetences">
        <div class="round figma neon">
            <img src="@/assets/figma.png" alt="">
            <p class="descr">Figma</p>
        </div>
      </div>

      <div class="centerCompetences">
        <div class="round vue">
          <img src="@/assets/vueJs.png" alt="">
          <p class="descr">Vue.js</p>
        </div>
        <div class="round javascript">
          <img src="@/assets/script-java.png" alt="">
          <p class="descr">JavaScript</p>
        </div>
      </div>

      <div class="bottomCompetences">
        <div class="round html">
          <img src="@/assets/html-5.png" alt="">
          <p class="descr">HTML5</p>
        </div>
        <div class="round css">
          <img src="@/assets/css-3.png" alt="">
          <p class="descr">CSS3</p>
        </div>
        <div class="round mysql">
          <img src="@/assets/mysql.png" alt="">
          <p class="descr">MySQL</p>
        </div>
        <div class="round php">
          <img src="@/assets/php.png" alt="">
          <p class="descr">PHP</p>
        </div>
        <div class="round symfony">
          <img src="@/assets/symfonyTest.png" alt="">
          <p class="descr">Symfony</p>
        </div>
      </div>

      <router-link to="/mescompetences" class="btnCompetences">Voir plus</router-link>
    </div>


  </section>


  <!-- Compétences darkMode -->

  <section v-if="darkMode" class="competencesDark">
    <h2>Mes compétences</h2>

    <div class="rounds">

      <div class="topCompetences">
        <div class="round roundDark figma neon">
            <img src="@/assets/figma.png" alt="">
            <p class="descr">Figma</p>
        </div>
      </div>

      <div class="centerCompetences">
        <div class="round roundDark vue">
          <img src="@/assets/vueJs.png" alt="">
          <p class="descr">Vue</p>
        </div>
        <div class="round roundDark javascript">
          <img src="@/assets/script-java.png" alt="">
          <p class="descr">JavaScript</p>
        </div>
      </div>

      <div class="bottomCompetences">
        <div class="round roundDark html">
          <img src="@/assets/html-5.png" alt="">
          <p class="descr">HTML5</p>
        </div>
        <div class="round roundDark css">
          <img src="@/assets/css-3.png" alt="">
          <p class="descr">CSS3</p>
        </div>
        <div class="round roundDark mysql">
          <img src="@/assets/mysql.png" alt="">
          <p class="descr">MySQL</p>
        </div>
        <div class="round roundDark php">
          <img src="@/assets/php.png" alt="">
          <p class="descr">PHP</p>
        </div>
        <div class="round roundDark symfony">
          <img src="@/assets/symfonyTest.png" alt="">
          <p class="descr">Symfony</p>
        </div>
      </div>

      <router-link to="/mescompetences" class="btnCompetences btnCompetencesDark">Voir plus</router-link>
    </div>


  </section>





  <!-- Projets en !darkMode -->

  <section v-if="!darkMode" class="projets">
    <h2>Mes projets</h2>

    <div class="myProjets">
      <div class="containerP">

        <input type="radio" name="slide" id="c1" checked>
        <label for="c1" class="cardP c1">
          <div class="rowP">
            <div class="icon">1</div>
            <div class="descrP">
              <h3>'Loading...' Texte Néon''</h3>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c2">
        <label for="c2" class="cardP c2">
          <div class="rowP">
            <div class="icon">2</div>
            <div class="descrP">
              <h3>Jeu du morpion</h3>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c3">
        <label for="c3" class="cardP c3">
          <div class="rowP">
            <div class="icon">3</div>
            <div class="descrP">
              <h3>Jeu de Shi-Fu-Mi</h3>
            </div>
          </div>
        </label>
      </div>
    </div>

    <router-link to="/projets" class="btnProjets">Découvrir d'avantage</router-link>

  </section>


  <!-- Projets darkMode -->

  
  <section v-if="darkMode" class="projetsDark">
    <h2>Mes projets</h2>

    <div class="myProjets">
      <div class="containerP">

        <input type="radio" name="slide" id="c1" checked>
        <label for="c1" class="cardP cardPDark c1">
          <div class="rowP">
            <div class="iconDark">1</div>
            <div class="descrP descrPDark">
              <h3>'Loading...' Texte Néon''</h3>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c2">
        <label for="c2" class="cardP cardPDark c2">
          <div class="rowP">
            <div class="iconDark">2</div>
            <div class="descrP descrPDark">
              <h3>Jeu du morpion</h3>
            </div>
          </div>
        </label>

        <input type="radio" name="slide" id="c3">
        <label for="c3" class="cardP cardPDark c3">
          <div class="rowP">
            <div class="iconDark">3</div>
            <div class="descrP descrPDark">
              <h3>Jeu de Shi-Fu-Mi</h3>
            </div>
          </div>
        </label>
      </div>
    </div>

    <router-link to="/projets" class="btnProjets btnProjetsDark">Découvrir d'avantage</router-link>

  </section>






  <!-- Contact !darkMode -->

  <section v-if="!darkMode" id="contact" class="contact">
    <h2>Contact</h2>

    <div class="containerC">
      <div class="contactL">
        <h4>Me contacter</h4>
        <p>Je suis ouverte aux opportunités de collaboration et enthousiaste d'échanger avec vous.</p>
        <div class="infosL">
          <div class="icons">
            <img src="@/assets/tel.png" alt="">
            <p>0660 98 58 60</p>
          </div>
          <div class="icons">
            <img src="@/assets/mail.png" alt="">
            <p>gastrin.ce@gmail.com</p>
          </div>
          <div class="icons iconsLink" @click="openLinkedin">
            <img src="@/assets/linkedin.png" alt="">
            <p>Lien de mon profil LinkedIn</p>
          </div>
        </div>
      </div>

      <div class="contactR">
        <h4>Envie de collaborer ?</h4>
        <h4>Let it cloud !</h4>
        <p>Veuillez remplir le formulaire ci-dessous :</p>

        <div class="form">
          
          <form
            action="https://formspree.io/f/mblrbknp"
            method="POST"
            @submit.prevent="submitForm"
          >

          <input type="text" name="nom" placeholder="Nom" v-model="form.nom" required>
          <input type="text" name="prenom" placeholder="Prénom" v-model="form.prenom" required>
          <input type="email" name="email" placeholder="Email" v-model="form.email" required>
          <textarea name="message" placeholder="Message" class="inputMsg" v-model="form.message" required></textarea>

          <div class="confetti">
            <button type="submit" class="btnCDark" id="btnC" @click="animateSpans">Envoyer
              <span v-for="n in 20" :key="n"></span>
            </button>
          </div>
        </form>

        </div>

      </div>
    </div>
  </section>


  
  <!-- Contact en darkMode -->

  <section v-if="darkMode" id="contact" class="contactDark">
    <h2>Contact</h2>

    <div class="containerC">
      <div class="contactL contactLDark">
        <h4>Me contacter</h4>
        <p>Je suis ouverte aux opportunités de collaboration et enthousiaste d'échanger avec vous.</p>
        <div class="infosL">
          <div class="icons">
            <img src="@/assets/tel.png" alt="">
            <p>0660 98 58 60</p>
          </div>
          <div class="icons">
            <img src="@/assets/mail.png" alt="">
            <p>gastrin.ce@gmail.com</p>
          </div>
          <div class="icons iconsLink" @click="openLinkedin">
              <img src="@/assets/linkedin.png" alt="">
              <p>Lien de mon profil LinkedIn</p>
          </div>
        </div>
      </div>

      <div class="contactR contactRDark">
        <h4>Envie de collaborer ?</h4>
        <h4>Let's align the stars!</h4>
        <p>Veuillez remplir le formulaire ci-dessous :</p>

        <div class="form">

          <form
            action="https://formspree.io/f/mblrbknp"
            method="POST"
            @submit.prevent="submitForm"
          >

          <input type="text" name="nom" placeholder="Nom" v-model="form.nom" required>
          <input type="text" name="prenom" placeholder="Prénom" v-model="form.prenom" required>
          <input type="email" name="email" placeholder="Email" v-model="form.email" required>
          <textarea name="message" placeholder="Message" class="inputMsg" v-model="form.message" required></textarea>

          <div class="confetti">
            <button type="submit" class="btnCDark" id="btnC" @click="animateSpans">Envoyer
              <span v-for="n in 20" :key="n"></span>
            </button>
          </div>
        </form>

        </div>

      </div>
    </div>
  </section>


  </div>
</template>

<script>


export default {

  data() {
    return {
      scrolling: false,
      lastScrollPosition: 0,
      isDropdownOpen: true,
      cvOpen: true,

      form: {
        nom: '',
        prenom: '',
        email: '',
        message: ''
      },

      currentRoute: this.$route.path,
      hoveredLink: null

    };
    
  },

  watch: {
    $route(to) {
      this.currentRoute = to.path;
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount(){
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    
    handleScroll() {
      const scrollPosition = window.scrollY;
      const cloud = document.getElementById('cloud');

      if(cloud) {
        cloud.style.transform = `translateY(-${scrollPosition}px)`;
      }

      const sun = document.getElementById('sun');

      if(sun) {
        sun.style.transform = `translateY(-${scrollPosition}px)`;
      }

      const shadow = document.getElementById('shadow');

      if(shadow) {
        shadow.style.transform = `translateY(-${scrollPosition}px)`;
      }



      if(scrollPosition > this.lastScrollPosition) {
        this.scrolling = true;
      } else {
        this.scrolling = false;
      }

      this.lastScrollPosition = scrollPosition;

      

    },

    toggleDropDown() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },

    changeDarkMode(){
      this.darkMode = !this.darkMode;
    },

    ouvrirCv(){
      this.cvOpen = !this.cvOpen
    },

    fermerCv(){
      this.cvOpen = !this.cvOpen
    },

      setHover(link) {
        this.hoveredLink = link;
      },
      clearHover() {
        this.hoveredLink = null;
      },

    animateSpans() {
      const spans = this.$el.querySelectorAll('#btnC span');
      spans.forEach(span => {
        span.classList.add('anim');
      });

        setTimeout(() => {
          spans.forEach(span => {
            span.classList.remove('anim');
          })
        }, 1500);
    },

    openLinkedin(){
      window.open('https://www.linkedin.com/in/c%C3%A9cile-gastrin-981107217/','_blank', 'noopener,noreferrer');
    },

    async submitForm() {

      try {
        const formData = new FormData(document.querySelector('form'));
        await fetch('https://formspree.io/f/mblrbknp', {
          method: 'POST',
          body: formData
        });

        this.form.nom = '';
        this.form.prenom = '';
        this.form.email = '';
        this.form.message = '';

        alert('Message envoyé !');

      } catch (error) {
        console.error('Erreur de soumission:', error);
      }
    },

  },



  // name: 'HomeView',
  components: {
  },

  computed: {
    darkMode(){
      return this.$store.state.darkMode
    }
  },
}
</script>

<style scoped>
*, ::before, ::after{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root{
  --bleuClair-color: #0074CC;
  --bleuFonce-color: #004080;
}

.home{
  width: 100%;
}

/* Background darkMode */

.bgCloud{
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/fond-bg-portfolio.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat; 
}

/*  */

/* Background !darkMode */

.dark_mode{
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #000200;
  display: flex;
  justify-content: center;
  align-items: center;
}


.textCloudDark h1{
  color: transparent;
  font-weight: 900;
  font-size: 45px;
  -webkit-text-stroke: 0.01rem #fff;
  font-family: 'Holtwood One SC', sans-serif;
  opacity: 1;
  transition: opacity 0.5s ease;
  text-transform: uppercase;
}

.dark_mode .star{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: animate 8s ease-in-out infinite,
            backgroundmove 16s linear infinite;

}

.dark_mode .star.star1{
  animation-delay: 0s;
  background: url('@/assets/star1.png');
  
}

.dark_mode .star.star2{
  animation-delay: -1s;
  background: url('@/assets/star2.png');
  
}

.dark_mode .star.star3{
  animation-delay: -2s;
  background: url('@/assets/star3.png');
  
}

.dark_mode .star.star4{
  animation-delay: -3s;
  background: url('@/assets/star4.png');
  
}

.dark_mode .star.star5{
  animation-delay: -4s;
  background: url('@/assets/star5.png');
  
}

.dark_mode .star.star6{
  animation-delay: -5s;
  background: url('@/assets/star6.png');
  
}

.dark_mode .star.star7{
  animation-delay: -6s;
  background: url('@/assets/star7.png');
  
}

.dark_mode .star.star8{
  animation-delay: -7s;
  background: url('@/assets/star8.png');
  
}  

@keyframes animate {
  0%, 20%, 40%, 60%, 80%, 100%{
    opacity: 0;
  }

  10%, 30%, 50%, 70%, 90%{
    opacity: 1;
  }
}

@keyframes backgroundmove {
  0%{
    transform: scale(1);
  }
  100%{
    transform: scale(2);
  }
}

/*  */

.cloudShadow{
  width: 80%;
  max-width: 900px;
  height: auto;
  margin: 0 auto;
  position: relative;
}

.cloud{
  position: relative;
  filter: brightness(1.03) contrast(1);
  animation: move 8s linear infinite;
  z-index: 1;
  animation: bougeNuage 10s linear infinite;
  bottom: 20px;
}

@keyframes bougeNuage {
  0%{
    transform: translateX(-50px);
  }
  50%{
    transform: translateX(50px);
  }
  100%{
    transform: translateX(-50px);
  }
}


.sun{
  position: absolute;
  top: 50px;
  left: 480px;
  margin: 0;
  padding: 0;
  width: 150px;
  height: 150px;
  background: #eed40e;
  border-radius: 50%;
  box-shadow: 0 0 45px rgba(238, 212, 14, 0.5);
  z-index: 0;
  animation: sunAnimate 30s linear infinite;
}

@keyframes sunAnimate {
  0%{
    transform: rotate(0deg);
  }
  50%{
    transform: rotate(90deg);
  }
  100%{
    transform: rotate(360deg);
  }
}

.sun li {
  list-style: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 5px;
  background: #eed40e;
  box-shadow: 0 0 15px rgba(238, 212, 14, 0.7);
}

.sun li:nth-child(1){
  transform: translate(-50%, -50%) rotate(0deg);

}

.sun li:nth-child(2){
  transform: translate(-50%, -50%) rotate(900deg);

}

.sun li:nth-child(3){
  transform: translate(-50%, -50%) rotate(45deg);
}

.sun li:nth-child(4){
  transform: translate(-50%, -50%) rotate(-45deg);
}

.sun li:nth-child(5){
  transform: translate(-50%, -50%) rotate(22.5deg);
}

.sun li:nth-child(6){
  transform: translate(-50%, -50%) rotate(-22.5deg);

}

.sun li:nth-child(7){
  transform: translate(-50%, -50%) rotate(67.5deg);

}

.sun li:nth-child(8){
  transform: translate(-50%, -50%) rotate(-67.5deg);

}

.sun li:nth-child(9){
  transform: translate(-50%, -50%) rotate(90deg);

}





#cloud{
  transition: transform 0.5s ease;
  transform: translateY(-50%);
}

#sun{
  transition: transform 0.5s ease;
  transform: translateY(-50%);
}

.roundCloudL,
.roundCloudCT,
.roundCloudCB,
.roundCloudCR,
.roundCloudR {
  background-color: #F2FAFC;
  position: absolute;
  border-radius: 50%;
  filter: blur(6px);
}

.roundCloudL{
  width: 200px;
  height: 200px;
  top: 180px;
  left: 180px;
  box-shadow: 0 0 100px rgba(1, 50, 122, 0.4) inset;
  filter: blur(2px);

}

.roundCloudCT{
  width: 250px;
  height: 250px;
  top: 57px;
  left: 280px;
  box-shadow: 0 0 130px rgba(1, 50, 122, 0.4) inset;
  filter: blur(6px);
}

.roundCloudCB{
  width: 200px;
  height: 200px;
  top: 220px;
  left: 330px;
  box-shadow: 0 0 90px rgba(1, 50, 122, 0.4) inset;
  filter: blur(6px);

}
.roundCloudCR{
  width: 200px;
  height: 200px;
  top: 170px;
  left: 430px;
  box-shadow: 0 0 80px rgba(1, 50, 122, 0.4) inset;
  filter: blur(6px);

}
.roundCloudR{
  width: 150px;
  height: 150px;
  top: 200px;
  left: 560px;
  box-shadow: 0 0 70px rgba(1, 50, 122, 0.4) inset;
  filter: blur(3px);

}

.textCloud{
  position: absolute;
  top: 70vh;
  left: 50%;
  transform:  translate(-50%, -50%);
  text-align: center;
  color: #004080;
  font-family: 'Holtwood One SC', sans-serif;
  opacity: 1;
  transition: opacity 0.5s ease;

}

.textCloud.hidden{
  display: none;
  opacity: 0;
}

.textCloud .name{
  -webkit-text-stroke: 0.2px #004080;
  color: transparent;
  font-size: 2.8rem;


}


.textCloud .descr{
  margin-bottom: 10px;
  -webkit-text-stroke: 0.1px #004080; /*pour tous les nav le comprend la bordure au texte */
  color: transparent;
  font-size: 1.75rem;

}

.seeMore{
  font-size: 0.875rem;
  font-family: 'Quicksand', sans-serif;
}

.shadow{
  position: absolute;
  width: 500px;
  height: 20px;
  background-color: #004080;
  filter: blur(30px);
  margin-top: 640px;
  margin-left: -240px;
  border-radius: 20px;
}


/* responsive !darkMode */

@media screen and (max-width: 599px) {
  .cloud,
  #sun,
  .shadow {
    display: none;
  }

  .textCloud {
    width: 100%;
    top: 50vh;
  }

  .textCloud .name {
    font-size: 1.2rem;
  }

  .textCloud .descr {
    font-size: 1rem;
  }

  .seeMore {
    font-size: 0.8rem;
  }

}

@media screen and (min-width: 600px) and (max-width: 1024px) {

  .cloud,
  #sun,
  .shadow {
    display: none;
  }

  .textCloud {
    width: 100%;
    top: 50vh;
  }

  .textCloud .name {
    font-size: 1.6rem;
  }

  .textCloud .descr {
    font-size: 1.3rem;
  }

  .seeMore {
    font-size: 0.9rem;
  }

}


@media screen and (min-width: 1025px) and (max-width: 1280px) {

  .textCloud .name {
    font-size: 2.2rem;
  }

  .textCloud .descr {
    font-size: 1.6rem;
  }

  .seeMore {
    font-size: 1rem;
  }
}



/* @media screen and (max-width: 768px) {

  .cloud{
    width: 60%;
    max-width: 80%;
    left: -8rem;
  }

  #sun{
    width: 150px;
    height: 150px;
    top: 80px;
    left: 55%;
    transform: translateX(-50%);
  }

  #sun li{
    width: 220px;
    height: 4px;
    
  }

  .textCloud .name{
    font-size: 31px;
  }

  .textCloud .descr{
    font-size: 20px;
  }

  .seeMore{
    font-size: 13px;
  }

  .textCloud{
    top: 500px;
  }
} */

  /*

@media screen and (min-width: 390px) and (max-width: 768px) {

  .cloud {
    left: -20rem;
  }

  #sun {
    width: 100px;
    height: 100px;
    top: 130px;
    left: 60%;
    transform: translateX(-50%);
  }

  #sun li {
    width: 130px;
    height: 3px;
  }

  .textCloud .name {
    font-size: 15px;
  }

  .textCloud .descr {
    font-size: 11px;
  }

  .seeMore {
    font-size: 10px;
  }

  .textCloud {
    top: 540px;
  }

}
  */



/* responsive darkMode */
@media screen and (min-width: 390px) and (max-width: 767px) {
  .textCloudDark {
    top: 70%;
    padding: 0 5px;
  }

  .textCloudDark .nameD {
    font-size: 20px;
  }

  .textCloudDark .descrC {
    font-size: 16px;
  }

  .seeMoreD {
    font-size: 10px;
  }

  .star {
    width: 15px;
    height: 15px;
  }

}




/* NAV en !darkMode */


/* .navNav{
  display: flex;
}

nav{
  position: relative;
  width: 600px;
  height: 50px;
  background: rgba(0, 64, 128, 0.2);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
}

nav a{
  position: relative;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  color: #004080;
  text-decoration: none;
  padding: 0 40px;
  z-index: 1;
}

nav a:hover{
  color: #fff;
}


nav span{
  position: absolute;
  top: 0;
  left: 85px;
  width: 135px;
  height: 100%;
  background: linear-gradient(45deg, #004080, #0074CC);
  border-radius: 8px;
  transition: 0.5s;
  color: #fff;
  
}

nav a:nth-child(2):hover~span{
  left: 235px;

}

nav a:nth-child(3):hover~span{
  left: 405px;
  width: 90px;
}

.navR{
  margin-top: 28px;
  margin-right: 35px;
  width: 90px;
  height: 40px;
  background: #0074CC;
  border-radius: 10px;
  display: flex;
  justify-content: end;
  align-items: right;

}

.navR button{
  border: none;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  background: #0074CC;
  color: #fff;
  font-size: 14px;

} */



.navbar ul.links li{
  list-style: none;
}

.dropdown_menu li{
  list-style: none;
  display: flex;
  padding: 0.7rem;
  justify-content: center;
  align-items: center;
}

.navbar ul.links li a{
  text-decoration: none;
  color: #004080;
  font-size: 1rem;
}

.navbarDark ul.links li a{
  text-decoration: none;
  color: #fff;
  font-size: 1rem;
  z-index: 1000;
  position: relative;
}

.dropdown_menu li a{
  text-decoration: none;
  color: #004080;
  font-size: 1rem;
}

.navbar ul.links li a:hover{
  color: #FDB813;
}

.navbarDark ul.links li a:hover{
  color: #333;
}

.dropdown_menu li a:hover{
  color: #FDB813;
}

.toggle_btn img{
  width: 30px;
  height: 30px;
  cursor: pointer;
  object-fit: contain;
}


.toggle_btn{
  display: none;
}

.navbar{
  position: relative;
  padding: 0 2rem;
  width: 100%;
  height: 60px;
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
}

.navbar .links{
  display: flex;
  gap: 2rem;
}

.navbar ul span{
  position: absolute;
  top: -15px;
  left: 403px;
  width: 100px;
  height: 80%;
  background: linear-gradient(45deg, #004080, #0074CC);
  border-radius: 8px;
  transition: 0.5s;
  color: #fff;
  z-index: -1;

}

.navbarDark ul span{
  position: absolute;
  top: -15px;
  left: 403px;
  width: 100px;
  height: 80%;
  background: linear-gradient(45deg, #fff, #f1f1f1);
  border-radius: 8px;
  transition: 0.5s;
  background: rgba(255, 255, 255, 0.5);
  z-index: 0;
}

.navbar ul li:nth-child(2):hover~span{
  left: 505.5px;
  width: 120px;
}

.navbar ul li:nth-child(3):hover~span{
  left: 633px;
  width: 80px;
}

.navbarDark ul li:nth-child(2):hover~span{
  left: 505.5px;
  width: 120px;
}

.navbarDark ul li:nth-child(3):hover~span{
  left: 633px;
  width: 80px;
}

.btnContact{
  background-color: #004080;
  color: #fff;
  padding: 0.8rem 1rem;
  outline: none;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  margin-top: -10px;
  margin-bottom: 30px;
  transition: scale 0.2s ease;

}

.navbarDark .btnContact{
  background-color: #fff;
  color: #004080;
  padding: 0.8rem 1rem;
  outline: none;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  margin-top: -10px;
  margin-bottom: 30px;
  transition: scale 0.2s ease;
}

.btnContact:hover{
  scale: 1.05;
}

.btnContact:active{
  scale: 0.95;
}

.dropdown_menu{
  position: absolute;
  padding-top: 1rem;
  margin-top: -40px;
  left: 55%;
  width: 300px;
  height: auto;
  background: rgba(0, 64, 128, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  overflow: hidden;
  transition: height 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}


.dropdown_menu .btnContact{
  width: 100%;
  display: flex;
  justify-content: center;
  color: #fff;
}



@media screen and (max-width: 768px) {
  .dropdown_menu {
    left: 10%;
    width: 80%;
    background: rgb(255, 255, 255);
    backdrop-filter: none !important;
    box-shadow: none;
    opacity: 1;
    z-index: 9999;
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 40px;
  }
}




@media(max-width: 992px){
  .navbar .links,
  .navbar .btnContact{
    display: none;
  }

  .navbar .toggle_btn{
    display: block;
  }

  .dropdown_menu{
    display: block;
  }
}

ul .dropdown{
  position: absolute;
  left: 0;
  width: 200px;

}

@media screen and (min-width: 993px) and (max-width: 1004px){
  .navbar ul span{
    left: 300px;
  }
}

@media screen and (min-width: 1004px) and (max-width: 1010px){
  .navbar ul span{
    left: 305px;
  }
}

@media screen and (min-width: 1010px) and (max-width: 1019px){
  .navbar ul span{
    left: 310px;
  }
}

@media screen and (min-width: 1019px) and (max-width: 1030px){
  .navbar ul span{
    left: 315px;
  }
}

@media screen and (min-width: 1030px) and (max-width: 1040px){
  .navbar ul span{
    left: 320px;
  }
}

@media screen and (min-width: 1040px) and (max-width: 1050px){
  .navbar ul span{
    left: 325px;
  }
}

@media screen and (min-width: 1050px) and (max-width: 1060px){
  .navbar ul span{
    left: 330px;
  }
}

@media screen and (min-width: 1040px) and (max-width: 1050px){
  .navbar ul span{
    left: 325px;
  }
}

@media screen and (min-width: 1050px) and (max-width: 1060px){
  .navbar ul span{
    left: 330px;
  }
}

@media screen and (min-width: 1060px) and (max-width: 1070px){
  .navbar ul span{
    left: 335px;
  }
}

@media screen and (min-width: 1070px) and (max-width: 1080px){
  .navbar ul span{
    left: 340px;
  }
}

@media screen and (min-width: 1080px) and (max-width: 1091px){
  .navbar ul span{
    left: 345px;
  }
}

@media screen and (min-width: 1091px) and (max-width: 1100px){
  .navbar ul span{
    left: 350px;
  }
}

@media screen and (min-width: 1100px) and (max-width: 1110px){
  .navbar ul span{
    left: 355px;
  }
}

@media screen and (min-width: 1110px) and (max-width: 1120px){
  .navbar ul span{
    left: 360px;
  }
}

@media screen and (min-width: 1120px) and (max-width: 1130px){
  .navbar ul span{
    left: 365px;
  }
}

@media screen and (min-width: 1130px) and (max-width: 1140px){
  .navbar ul span{
    left: 370px;
  }
}

@media screen and (min-width: 1140px) and (max-width: 1150px){
  .navbar ul span{
    left: 375px;
  }
}

@media screen and (min-width: 1150px) and (max-width: 1160px){
  .navbar ul span{
    left: 380px;
  }
}

@media screen and (min-width: 1160px) and (max-width: 1170px){
  .navbar ul span{
    left: 385px;
  }
}

@media screen and (min-width: 1170px) and (max-width: 1180px){
  .navbar ul span{
    left: 390px;
  }
}

@media screen and (min-width: 1180px) and (max-width: 1190px){
  .navbar ul span{
    left: 395px;
  }
}

@media screen and (min-width: 1190px) and (max-width: 1200px){
  .navbar ul span{
    left: 400px;
  }
}




/* end navbar en !darkMode */


/* Dropdown compétences en darkMode */

.dropdownCompetences{
  padding: 14px;
  text-decoration: none;
}

/* end Dropdown competences en darkMode */




/* NavBar en darkMode */




/* end NavBar en darkMode */




/* ABOUT en darkMode */

.about{
  width: 100%;
  height: auto;
  /* background: red; */
  margin: 20px auto;
  overflow: hidden;
  color: #004080;

}

.about .aPropos{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #004080;
  color: transparent;
}

.about .aProposDark{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #fff;
  color: transparent;
}

.aboutLeft{
  float: left;
  position: relative;
  height: 400px;
  padding-right: 20px;
  margin-left: 100px;
  margin-top: 40px;
  font-size: 60px;
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #004080;
  
}

.aboutLeftDark{
  float: left;
  position: relative;
  height: 400px;
  padding-right: 20px;
  margin-left: 100px;
  margin-top: 40px;
  font-size: 60px;
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #fff;
  
}


.container{
    position: absolute;
    bottom: 0;
    left: 10rem;
    width: 100%;
    height: 30vh;
    z-index: 100;
}

.text{
    font-family: 'Quicksand', sans-serif;
    font-size: 100px;
    color: #004080;
    display: flex;
    position: absolute;
    bottom: 36vh;
    transform: translateX(-50%);
    user-select: none;
    height: 100%;
}


.textDark{
    font-family: 'Quicksand', sans-serif;
    font-size: 100px;
    color: #fff;
    display: flex;
    position: absolute;
    bottom: 36vh;
    transform: translateX(-50%);
    user-select: none;
    height: 100%;
}

.wrapper{
    padding-left: 20px;
    padding-right: 20px;
    position: relative;
}

.letter{
    transition: ease-out 1s;
    transform: translateY(40%);
}

.shadowText{
    transform: scale(1, -1);
    color: #D3D3D3;
    opacity: 0.3;
    transition: ease-in 1s, ease-out 5s;
}

.shadowTextDark{
    transform: scale(1, -1);
    color: #D3D3D3;
    opacity: 0.1;
    transition: ease-in 1s, ease-out 5s;
}

.wrapper:hover .letter{
    transform: translateY(-100%);
}

.wrapper:hover .shadowText{
    opacity: 0;
    transform: translateY(200%);
}

.wrapper:hover .shadowTextDark{
    opacity: 0;
    transform: translateY(200%);
}


.aboutRight{
  margin: 0 auto;
  width: 80%;
  height: 550px;
  padding-top: 100px;
  font-family: 'Quicksand';


}

.aboutRightDark{
  margin: 0 auto;
  width: 80%;
  height: 550px;
  padding-top: 100px;
  font-family: 'Quicksand';
  color: #fff;
}

.aboutRight h3{
  margin-left: 450px;
  margin-top: -60px;
}

.aboutRightDark h3{
  margin-left: 450px;
  margin-top: -60px;
}

.aboutRight .aboutMe{
  float: right;
  width: 800px;
  margin-top: 20px;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  line-height: 1.6;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  font-size: 16px;
}

.aboutRightDark .aboutMe{
  float: right;
  width: 800px;
  margin-top: 20px;
  background-color: #1e1e1e;
  padding: 20px;
  border-radius: 10px;
  line-height: 1.6;
  box-shadow: 0 4px 6px rgba(0,0,0,0.4);
  font-size: 16px;
}

.boutonCv{
  margin-top: 50px;
}

/* responsive a propos !darkMode */
@media screen and (min-width: 391px) and (max-width: 768px) {

  .aboutLeft{

  }

  .aboutLeftDark{
    margin-top: 230px;
    margin-left: 15rem;
    position: absolute;
  }

  .aboutRight{
    margin-top: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .aboutRightDark{
    margin-top: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .aboutRight h3{
    margin-left: 0;
  }

  .aboutRightDark h3{
    margin-left: 0;
  }

  .aboutRight .aboutMe{
    float: none;
    width: 100%;
  }

  .aboutRightDark .aboutMe{
    float: none;
    width: 100%;
  }

  .boutonCv{
    margin-top: 100px;
    margin-left: -28rem;
  }
}

@media screen and (max-width: 390px) {
  .aboutLeft{
    margin-top: 6rem;
    margin-left: 2rem;
    position: absolute;
  }

  .aboutLeftDark{
    margin-top: 6rem;
    margin-left: 2rem;
    position: absolute;
  }

  .aboutRight{
    margin-top: 150px;
    margin-bottom: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .aboutRightDark{
    margin-top: 150px;
    margin-bottom: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .aboutRight h3{
    margin-left: 0;
  }

  .aboutRightDark h3{
    margin-left: 0;
  }

  .aboutRight .aboutMe{
    float: none;
    width: 100%;
  }

  .aboutRightDark .aboutMe{
    float: none;
    width: 100%;
  }

  .boutonCv{
    margin-top: 450px;
    margin-left: -28rem;
  }
}





/* Compétences */

.competences{
  width: 100%;
  height: 100vh;

}

.competencesDark{
  width: 100%;
  height: 100vh;
}

.competences h2{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #004080;
  color: transparent;
}

.competencesDark h2{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #fff;
  color: transparent;
}

.rounds{
  height: 500px;
  margin: 50px auto;
  display: grid;
  grid-template-rows: repeat(3, 1fr);

}

.round{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 0.1px solid #0074CC;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.roundDark{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 0.1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.round:hover{
  position: relative;
  display: flex;
  width: 150px;
  height: 150px;
  border-radius: 50%;
}

@keyframes neon-animate {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
} 

.round::before{
  content: "";
  position: absolute;
  top: 6px;
  left: 6px;
  right: 6px;
  bottom: 6px;
  background: #fff;
  opacity: 0.7;
  border-radius: 50%;
  z-index: 1000;
} 

.round:hover::after{
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-radius: 50%;
  filter: blur(30px);
  animation: neon-animate 2s linear infinite;

} 

.round.figma:after{
  
  background: linear-gradient(45deg, #87CEEB, #D46457, #F44E1E, #A158FF, #09CD81);
}

.round.vue:after{
  background: linear-gradient(45deg, #00608A, #41B883);
}

.round.javascript:after{
  background: linear-gradient(45deg, #FFDA3E, #7e6b0b, #000000);
}

.round.html:after{
  background: linear-gradient(45deg, #F1813F, #E34C25, #000000);
}

.round.css:after{
  background: linear-gradient(45deg, #2965F1, #264DE4, #000000);
}

.round.mysql:after{
  background: linear-gradient(45deg, #00618B, #E78E00);
}

.round.php:after{
  background: linear-gradient(45deg, #95ACD8, #516192, #373353);
}

.round.symfony:after{
  background: linear-gradient(45deg, #CCCCCC, #000000);
}

.topCompetences{
  margin: 0 auto;
  margin-top: auto;

}

.centerCompetences{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 0 auto;
  gap: 20px;
  margin-top: auto;
}

.bottomCompetences{
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 30px auto;
  gap: 20px;
}

.round img{
  width: 50px;
  height: 50px;
  z-index: 2000;
  position: relative;
  
}

.round:hover img{
  width: 30px;
  height: 30px;

}

.round .descr{
  display: none;
  position: absolute;
  margin-top: 90px;
  font-family: 'Quicksand', sans-serif;
  color: #004080;
  font-weight: 600;
}

.round:hover .descr{
  display: block;
  z-index: 2000;

}


.btnCompetences{
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #fff;
  color: #004080;
  border: 1px solid #004080;
  border-radius: 20px;
  font-family: 'Quicksand', sans-serif;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.btnCompetencesDark{
  color:#000000;
  border: 1px solid #000000;
  border: 1px solid #fff;
}

.btnCompetences:hover{
  background-color: #004080;
  color: #fff;
}

.btnCompetencesDark:hover{
  background-color: #000000;
  color: #fff;
}

@media only screen and (max-width: 768px){
  .centerCompetences,
  .bottomCompetences {
    grid-template-columns: repeat(2, 1fr);
  }

  .competences, .competencesDark {
    margin-bottom: 6rem;
  }
}

@media screen and (max-width: 390px) {
  .competences, .competencesDark {
    margin-bottom: 15rem;
  }
}




/* Projets */

.projets{
  margin-top: 10px;
  width: 100%;
  height: 100vh;
}

.projetsDark{
  margin-top: 10px;
  width: 100%;
  height: 100vh;
}

.projets h2{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #004080;
  color: transparent;
}

.projetsDark h2{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #fff;
  color: transparent;
}

.myProjets{
  display: flex;
  justify-content: center;
  align-items: center;
}

.containerP{
  margin: 50px auto;
  height: 500px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
}

.cardP{
  width: 80px;
  border-radius: 10px;
  background-size: cover;
  cursor: pointer;
  overflow: hidden;
  margin: 0 10px;
  display: flex;
  align-items: flex-end;
  transition: 0.6s cubic-bezier(0.28,-0.03,0,0.99);
  box-shadow: 0px 10px 30px -5px rgba(0, 64, 128, 1);
}

.cardPDark{
  box-shadow: 0px 10px 30px -5px rgba(255, 255, 255, 0.4);
}

.rowP{
  color: white;
  display: flex;
  flex-wrap: nowrap;
}

.icon{
  background: #004080;
  color: white;
  border-radius: 50%;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px;
}

.iconDark{
  background: black;
  color: #fff;
  border-radius: 50%;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px;
}

.descrP{
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  height: 80px;
  width: 520px;
  opacity: 0;
  transform: translateY(30px);
  transition-delay: 0.3s;
  transition: all 0.3s ease;
}

.descrP h3{
  text-align: start;
  text-transform: uppercase;
  font-family: 'Quicksand', sans-serif;
  color: #004080;
}

.descrPDark h3{
  color: black;
}

.containerP input{
  display: none;
}

input:checked + label {
  width: 600px;
}

input:checked + label .descrP{
  opacity: 1;
  transform: translateY(0px);
}

.c1{
  background-image: url('@/assets/textNeon.png');
  background-position: -200px 0px;
}

.c2{
  background-image: url('@/assets/morpion.png');
}

.c3{
  background-image: url('@/assets/shi-fu-mi.png');
  background-position: -170px 0px;

}

.btnProjets{
  padding: 10px 20px;
  background-color: #fff;
  color: #004080;
  border: 1px solid #004080;
  border-radius: 20px;
  font-family: 'Quicksand', sans-serif;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.btnProjetsDark{
  color:#000000;
  border: 1px solid #fff;
}

.btnProjets:hover{
  background-color: #004080;
  color: #fff;
}

.btnProjetsDark:hover{
  background-color: #000000;
  color: #fff;
}



/* responsive Projets */
@media screen and (min-width: 391px) and (max-width: 768px) {
  .projets {
    display: none;
    
  }

  .projetsDark {
    width: 90%;
    margin: 0 auto;
  }

  .cardP {
    width: 80px;
    margin: 5px 0;
  }

}

@media screen and (max-width: 390px) {
  .projets {
    padding: 10px;
  }

  .projetsDark {
    padding: 10px;
  }

  .containerP {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cardP {
    width: 50%; 
    margin: 5px 0;
  }

  .iconDark {
    font-size: 20px;
  }

  .descrP h3 {
    font-size: 16px;
  }

  .btnProjets {
    font-size: 12px;
    padding: 8px 16px;
  }

  .btnProjetsDark {
    font-size: 12px;
    padding: 8px 16px;
  }
}








/* Contact */

.contact{
  width: 100%;
  height: 100vh;
  margin: 0 auto 0;
}

.contactDark{
  width: 100%;
  height: 100vh;
  margin: 30px auto 0;
}

.contact h2{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #004080;
  color: transparent;
}


.contactDark h2{
  font-family: 'Holtwood One SC', sans-serif;
  -webkit-text-stroke: 0.2px #fff;
  color: transparent;
}

.containerC{
  display: flex;
  position: relative;
  width: 80%;
  height: 600px;
  margin: 0 auto;
}

.contactL{
  position: relative;
  flex: 1;
  margin-top: 30px;
  margin-left: 100px;
  background-color: #0074CC;
  color: #fff;
  text-align: start;
  padding: 40px;
  padding-bottom: 60px;
  
}

.contactLDark{
  flex: 1;
  margin-top: 30px;
  margin-left: 100px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: start;
  padding: 40px;
  padding-bottom: 60px;
}

.contactL h4{
  font-size: 30px;
}

.contactL p{
  font-size: 14px;
  margin-top: 30px;
}


.icons{
  display: flex;
  margin-top: 20px;
  align-items: center;
}

.icons img{
  width: 40px;
  height: 40px;
  margin-right: 20px;
}

.icons p{
  padding-bottom: 30px;
}

.iconsLink img{
  cursor: pointer;
}

.iconsLink p{
  cursor: pointer;
}

.contactR{
  flex: 1;
  margin-top: 30px;
  margin-right: 100px;
  background-color: #D9D9D9;
  color: #004080;
  text-align: start;
  padding: 40px;
}

.contactRDark{
  flex: 1;
  margin-top: 30px;
  margin-bottom: 10px;
  margin-right: 100px;
  background-color: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: start;
  padding: 40px;
}

.contactR h4{
  font-size: 30px;
}

.contactR p{
  font-size: 14px;
  margin-top: 30px;
}

.contactR input{
  display: flex;
  margin-top: 20px;
  width: 80%;
  height: 20px;
}

textarea.inputMsg{
  margin-top: 20px;
  height: 80px;
  width: 80%;
}

.contactR button{
  font-size: 1em;
  margin-top: 60px;
  margin-left: 242px;
  cursor: pointer;
  padding: 10px;
  width: 100px;
  background-color: #0074CC;
  color: #fff;
  border: none;
  box-shadow: 0 2px 25px rgba(0, 0, 0, 0.5);
  transition: box-shadow 0.25s;
  z-index: 2;
}

.contactRDark button{
  font-size: 1em;
  margin-top: 60px;
  margin-left: 242px;
  cursor: pointer;
  padding: 10px;
  width: 100px;
  background-color: #fff;
  color: #000;
  border: none;
  box-shadow: 0 2px 25px rgba(211, 211, 211, 0.5);
  transition: box-shadow 0.25s;
  z-index: 2;
}

.contactRDark button:active{
  background: gray;
  box-shadow: 0 2px 25px rgba(211, 211, 211, 0.2);

}

.btnC span{
  position: absolute;
  background: #0074CC;
  border: 1px solid #0074CC;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  transform: scale(0);
  opacity: 1;
}

.btnCDark span{
  position: absolute;
  background: white;
  border: 1px solid white;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  transform: scale(0);
  opacity: 1;
}



.btnC span:nth-child(1){
  top: 73%;
  left: 73%;
}
.btnC span:nth-child(2){
  top: 80%;
  left: 84%;
}
.btnC span:nth-child(3){
  top: 76%;
  left: 75%;
}
.btnC span:nth-child(4){
  top: 70%;
  left: 76%;
  background: transparent;
}
.btnC span:nth-child(5){
  top: 74%;
  left: 77%;
  background: transparent;
}
.btnC span:nth-child(6){
  top: 71%;
  left: 79%;
}
.btnC span:nth-child(7){
  top: 75%;
  left: 81%;
}
.btnC span:nth-child(8){
  top: 70%;
  left: 82%;
}
.btnC span:nth-child(9){
  top: 73%;
  left: 83%;
  background: transparent;
}
.btnC span:nth-child(10){
  top: 71%;
  left: 71.5%;
  background: transparent;
}
.btnC span:nth-child(11){
  top: 87%;
  left: 72%;
  background: transparent;
}
.btnC span:nth-child(12){
  top: 90%;
  left: 70%;
}
.btnC span:nth-child(13){
  top: 85.5%;
  left: 74%;
}
.btnC span:nth-child(14){
  top: 90%;
  left: 75%;
}
.btnC span:nth-child(15){
  top: 89%;
  left: 78%;
  background: transparent;
}
.btnC span:nth-child(16){
  top: 87%;
  left: 80%;
}
.btnC span:nth-child(17){
  top: 88%;
  left: 82%;
  background: transparent;
}
.btnC span:nth-child(18){
  top: 90%;
  left: 84%;
}
.btnC span:nth-child(19){
  top: 85%;
  left: 84%;
  background: transparent;
}
.btnC span:nth-child(20){
  top: 75%;
  left: 70%;
}

/* dark */
.btnCDark span:nth-child(1){
  top: 73%;
  left: 73%;
}
.btnCDark span:nth-child(2){
  top: 80%;
  left: 84%;
}
.btnCDark span:nth-child(3){
  top: 76%;
  left: 75%;
}
.btnCDark span:nth-child(4){
  top: 70%;
  left: 76%;
  background: transparent;
}
.btnCDark span:nth-child(5){
  top: 74%;
  left: 77%;
  background: transparent;
}
.btnCDark span:nth-child(6){
  top: 71%;
  left: 79%;
}
.btnCDark span:nth-child(7){
  top: 75%;
  left: 81%;
}
.btnCDark span:nth-child(8){
  top: 70%;
  left: 82%;
}
.btnCDark span:nth-child(9){
  top: 73%;
  left: 83%;
  background: transparent;
}
.btnCDark span:nth-child(10){
  top: 71%;
  left: 71.5%;
  background: transparent;
}
.btnCDark span:nth-child(11){
  top: 87%;
  left: 72%;
  background: transparent;
}
.btnCDark span:nth-child(12){
  top: 90%;
  left: 70%;
}
.btnCDark span:nth-child(13){
  top: 85.5%;
  left: 74%;
}
.btnCDark span:nth-child(14){
  top: 90%;
  left: 75%;
}
.btnCDark span:nth-child(15){
  top: 89%;
  left: 78%;
  background: transparent;
}
.btnCDark span:nth-child(16){
  top: 87%;
  left: 80%;
}
.btnCDark span:nth-child(17){
  top: 88%;
  left: 82%;
  background: transparent;
}
.btnCDark span:nth-child(18){
  top: 90%;
  left: 84%;
}
.btnCDark span:nth-child(19){
  top: 85%;
  left: 84%;
  background: transparent;
}
.btnCDark span:nth-child(20){
  top: 75%;
  left: 70%;
}

.anim{
  animation: moving 1s linear reverse forwards;
}

@keyframes moving {
  0%{
    transform: scale(0);
  }
  50%{
    transform: scale(1);
  }
  100%{
    top: 80%;
    left: 77%;
  }
}

@media screen and (min-width: 391px) and (max-width: 768px) {
 .containerC {
  display: none;
 }

 .btnCDark span {
    background: white;
    border: 1px solid white;
    margin-bottom: 50px;
    margin-left: 230px;
  }

}

@media screen and (max-width: 390px) {
  .containerC {
    display: flex;
    flex-direction: column;
    align-items: center; 
  }

  .icons {
    display: flex;
    margin-bottom: -30px;
    align-items: center;
  }

  .contactL, .contactR {
    width: 100%;
    margin: 0 0; 
    box-sizing: border-box;
  }

  .contactL, .contactR {
    text-align: center;
  }

  .infosL {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .form input, .form textarea {
    width: 100%;
  }

  .contactR button, .contactRDark button {
    font-size: 1em;
    margin: 10px auto;
    display: block;
    padding: 10px;
    width: 80%;
    max-width: 300px;
    background-color: #0074CC;
    color: #fff;
    border: none;
    box-shadow: 0 2px 25px rgba(0, 0, 0, 0.5);
    transition: box-shadow 0.25s;
    z-index: 2;
    text-align: center;
  }

  .contactRDark button {
    background-color: #fff;
    color: #000;
    box-shadow: 0 2px 25px rgba(211, 211, 211, 0.5);
  }

  .contactRDark button:active {
    background: gray;
    box-shadow: 0 2px 25px rgba(211, 211, 211, 0.2);
  }

  .btnCDark span {
    background: white;
    border: 1px solid white;
    margin-top: 380px;
    margin-left: -100px;
  }



}









/* CV */

.btnCv{
  position: absolute;
  padding: 10px 20px;
  border: 1px solid #fff;
  color: #fff;
  background: #004080;
  font-size: 16px;
  cursor: pointer;
  margin-top: -150px;
  margin-left: 175px;
}

.btnCvDark{
  position: absolute;
  padding: 10px 20px;
  border: 1px solid #004080;
  color: #004080;
  background: #fff;
  font-size: 16px;
  cursor: pointer;
  margin-top: -150px;
  margin-left: 175px;
}

.content{
  position: relative;
}

.contentDark{
  position: relative;
}

.content-cv{
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 1000;
  margin-top: -590px;
  background: rgba(255, 255, 255, 1);
}

.content-cvDark{
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 1000;
  margin-top: -590px;
  background: rgba(0, 0, 0, 1);
}

.content-cvDark h1{
  color: #fff;
}

iframe{
  margin-top: 14px;
  width: 50%;
  height: 500px;
}

.content-cv button{
  position: absolute;
  padding: 5px 10px;
  margin-top: -25px;
  margin-left: -40px;
  border-radius: 50px;
  cursor: pointer;
}

.content-cvDark button{
  position: absolute;
  padding: 5px 10px;
  margin-top: -25px;
  margin-left: -40px;
  border-radius: 50px;
  cursor: pointer;
}




</style>